<template>
  <v-card
    class="rounded-xl ma-2 pa-5"
    max-width="400px"
  >
    <v-card-title>
      Requirements
    </v-card-title>

    <v-card
      v-for="(requirement, i) in requirements"
      :key="i"
      flat
    >
      <v-checkbox
        v-model="requirement.selected"
        :label="`${requirement.Requirement}`"
        :value="`${requirement.Value}`"
        :disabled="$store.getters.loadingApp === 1"
      />
    </v-card>

    <v-card
      flat
      class="pa-4 mt-2"
      max-width="300px"
    >
      <v-select
        v-model="service.invoice_mode"
        :items="invoiceModes"
        label="Invoice Mode"
        :disabled="$store.getters.loadingApp === 1"
        hint="When is the invoice available to the client in Packagemaker"
        persistent-hint
        :rules="inputRulesReq"
      />
    </v-card>

    <v-card
      flat
      class="pa-4 mt-2"
      max-width="300px"
    >
      <v-text-field
          v-model.number="service.planning_days"
          label="Planning days"
          type="number"
          min="0"
          step="1"
          :disabled="$store.getters.loadingApp === 1"
          hint="Days ahead to search for the first available date in Packagemaker"
          persistent-hint
          :rules="numberRule"
      />
    </v-card>

    <v-card
      flat
      class="pa-4 mb-2"
      max-width="300px"
    >
      <v-select
        v-model="service.min_level_spanish"
        :items="spanishLevelSelect"
        prepend-icon="mdi-school"
        label="Minimal Spanish level at start"
        clearable
        :disabled="$store.getters.loadingApp === 1"
      />
    </v-card>
  </v-card>
</template>

<script>
import inputRules from '@/mixins/inputRules'

export default {
  name: 'ServiceRequirements',

  mixins: [
      inputRules,
  ],

  props: {
    service: {
      type: Object,
      default: () => ({}),
    },

    requirements: {
      type: Array,
      default: () => [],
    },

    invoiceModes: {
      type: Array,
      default: () => [],
    },

    spanishLevelSelect: {
      type: Array,
      default: () => [],
    },
  },
}
</script>